import React from "react";

import HomeUI from "../../../ui/homeUI/_index";

const PersonalRedWorkReport = () => {
  return (
    <>
      <HomeUI />
    </>
  )
}

export default PersonalRedWorkReport
